module.exports = __webpack_public_path__ + "static/media/Piercing-belly-top.6a169464.png";